import React, { Component } from 'react';
import { Button } from 'formlabs-web-components/Link';

class ButtonPlugin extends Component {
  render() {
    const { buttonText, arrow, color, url } = this.props;
    return (
      <Button arrow={arrow} color={color} url={url}>
        {buttonText}
      </Button>
    );
  }
}

export default ButtonPlugin;
